import React, { useState, useEffect } from 'react';
import './UserCard.scss';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import AnimatedPulse from '../../../components/Loading/AnimatedPulse/AnimatedPulse';
// import { licenseDetails } from '../../../helpers/constants';
// import LicenseBadge from '../../../components/Badges/LicenseBadge/LicenseBadge';
import { useLogoutMutation } from '../../../store/services/authApi';

interface UserCardProps {
  name: string;
  isInstitution?: Boolean; //we need to identify whether to display one or two initials
  // role?: string;
}

function UserCard({ name, isInstitution = false }: UserCardProps) {
  const [logout, formStatus] = useLogoutMutation();
  const [initials, setInitials] = useState('');
  // const [license, setLicense] = useState<any>({});
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState: boolean) => !prevState);

  useEffect(() => {
    if (name) {
      const nameArray = name.split(' ');
      if (!isInstitution) setInitials(`${nameArray[0][0]}${nameArray.length > 1 ? nameArray[1][0] : ''}`.toLocaleUpperCase());
      else setInitials(`${nameArray[0][0]}`.toLocaleUpperCase());
    }

    // if (role) setLicense(licenseDetails.get(role));
  }, [name]);

  useEffect(() => {
    if (formStatus.isError) {
      alert('Something went wrong. Please try again.');
    } else if (formStatus.isSuccess) {
      window.location.reload();
    }
  }, [formStatus]);

  return (
    <div className="user-card-wrapper">
      <Dropdown isOpen={dropdownOpen} toggle={toggle} direction={'down'}>
        <DropdownToggle caret>
          {name ? (
            <div className="user-info-avatar-wrap flex flex-row">
              <div className="user-avatar">{initials}</div>
              <div className="flex flex-col flex-h-start">
                {/* <LicenseBadge displayText={license?.badge} color="green" /> */}
                <div className="user-name-wrap text-capitalize">{name}</div>
              </div>
            </div>
          ) : (
            <AnimatedPulse color="green" />
          )}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => logout('')}>
            <i className="icon icon-logout" /> Log out
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

export default UserCard;
